import React, { PureComponent } from 'react';
import { func, object } from 'prop-types';
import OrderHistoryCustomer from '../OrderHistoryCustomer';
import OrderPrintout from '../OrderPrintout';
import styles from './OrderHistoryDetails.scss';
import { translate } from 'react-i18next';
import { Tabs } from 'wix-style-react';

class OrderHistoryDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.ORDER_TAB_ID = 1;
    this.TAB_ITEMS = [
      {
        id: 1,
        title: this.props.t('phoneordering_menu_orderhistory_orderdetails_tab'),
        dataHook: 'order-history-order-details-tab',
      },
      {
        id: 2,
        title: this.props.t('phoneordering_menu_orderhistory_customerdetails_tab'),
        dataHook: 'order-history-customer-details-tab',
      },
    ];
    this.state = { activeTabId: this.ORDER_TAB_ID };
  }

  _handleTabClick = ({ id }) => {
    this.setState({ activeTabId: id });
  };

  componentDidUpdate() {
    this.props.onResize();
  }

  render() {
    const { activeTabId } = this.state;
    const { displayableOrder, onAddToOrderClick, orderAddress, restaurantAddress } = this.props;

    const orderTab = <OrderPrintout displayableOrder={displayableOrder} onAddToOrderClick={onAddToOrderClick} />;
    const customerTab = (
      <OrderHistoryCustomer
        restaurantAddress={restaurantAddress}
        orderAddress={orderAddress}
        displayableOrder={displayableOrder}
      />
    );

    return (
      <div className={styles.wrapper} data-hook="order-details-wrapper">
        <Tabs
          activeId={activeTabId}
          items={this.TAB_ITEMS}
          type="uniformFull"
          onClick={this._handleTabClick}
          minWidth={0}
        />
        {activeTabId === this.ORDER_TAB_ID ? orderTab : customerTab}
      </div>
    );
  }
}

OrderHistoryDetails.propTypes = {
  displayableOrder: object,
  onAddToOrderClick: func,
  orderAddress: object,
  restaurantAddress: object,
};

OrderHistoryDetails.defaultProps = {
  displayableOrder: {},
};

export default translate()(OrderHistoryDetails);
